import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ApiError } from '@/api';
import { notificationsService } from '@/modules/notifications/api/notifications.service';
import { notificationQueryKeys } from '@/modules/notifications/api/notifications.query-key';

/** Mark a single notification read, then refresh all notification lists. */
export function useMarkReadMutation() {
    const qc = useQueryClient();
    return useMutation<void, ApiError, string>({
        mutationFn: (id) => notificationsService.markRead(id),
        onSuccess:  () => { qc.invalidateQueries({ queryKey: notificationQueryKeys.lists() }); },
    });
}
